import { render, staticRenderFns } from "./PurchaseButton.vue?vue&type=template&id=4b39c8b2&scoped=true&"
import script from "./PurchaseButton.vue?vue&type=script&lang=ts&"
export * from "./PurchaseButton.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseButton.vue?vue&type=style&index=0&id=4b39c8b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39c8b2",
  null
  
)

export default component.exports